export default "__VITE_ASSET__3b24e33d__"